import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4v16","key":"svg-0"}],["path",{"d":"M8 6h12","key":"svg-1"}],["path",{"d":"M8 12h6","key":"svg-2"}],["path",{"d":"M8 18h10","key":"svg-3"}]]

/**
 * IconAlignLeft2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYWxpZ24tbGVmdC0yIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDR2MTYiIC8+CiAgPHBhdGggZD0iTTggNmgxMiIgLz4KICA8cGF0aCBkPSJNOCAxMmg2IiAvPgogIDxwYXRoIGQ9Ik04IDE4aDEwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/align-left-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconAlignLeft2 = createReactComponent('outline', 'align-left-2', 'AlignLeft2', __iconNode);

export default IconAlignLeft2;